import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconStarFilledStyle0 = gravityIconIndividualCss;

const GravityIconStarFilled = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '511dbeb97370100ab81676b8f212c908006f8e44', color: this.color, size: this.size }, h("svg", { key: '7cd9aa84a529098512dc84b56a6f07b57cfad8d2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'f20a69256c808c60787eb4301bc55ebed1c85550', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.113 19a.852.852 0 0 0 .426-.16l4.465-2.924 4.465 2.924a.88.88 0 0 0 .427.16c.32 0 .426-.267.293-.711l-1.432-4.942 3.914-3.458c.24-.205.329-.347.329-.525 0-.248-.187-.364-.649-.408l-4.883-.445-1.974-4.995c-.152-.374-.285-.516-.49-.516-.204 0-.346.151-.488.516L8.54 8.51l-4.892.445C3.187 9 3 9.116 3 9.364c0 .178.089.32.329.525l3.922 3.458-1.432 4.942c-.124.453-.017.711.294.711Z", fill: "currentColor" }))));
    }
};
GravityIconStarFilled.style = GravityIconStarFilledStyle0;

export { GravityIconStarFilled as gravity_icon_star_filled };

//# sourceMappingURL=gravity-icon-star-filled.entry.js.map